import { useQuery } from '@powersync/react';

import { acknowledgeRejection } from '@flow/domain';
import { applyLocalOperations, queries } from '@flow/sync';
import { RejectionNotice } from '@flow/ui/components';

import type { LocalDatabase } from '../db/powersync.js';
import { t } from '../i18n/es.js';

/**
 * Changes the server rejected (SYN-05, S6): the server's value already won on this device; this
 * says why, in plain words, until the user acknowledges it on any of their devices.
 */

interface RejectionRow {
  id: string;
  table_name: string;
  reason_code: string;
  message: string;
}

export function rejectionMessage(
  row: Pick<RejectionRow, 'table_name' | 'reason_code' | 'message'>,
) {
  if (row.reason_code === 'forbidden') return t.rejections.forbidden;
  if (row.table_name === 'highlights') return t.rejections.highlight(row.message);
  return t.rejections.generic(row.message);
}

export function Rejections({ local }: { local: LocalDatabase }) {
  const query = queries.unacknowledgedRejections();
  const { data } = useQuery<RejectionRow>(query.sql, query.params);
  return (
    <RejectionNotice
      items={data.map((row) => ({ id: row.id, message: rejectionMessage(row) }))}
      onAcknowledge={(id) => void applyLocalOperations(local.db, acknowledgeRejection({ id }))}
      labels={{ title: t.rejections.title, acknowledge: t.rejections.acknowledge }}
    />
  );
}
